module.exports = __webpack_public_path__ + "static/coliving-kitchen-3-e472f6dc0e5620b61e2ff90a35ce0678.jpg";